<div class="container mt-card">
    <div class="card mt-3">
        <div class="card-header">
            <h3>
                Examination Schedule
            </h3>
        </div>
        <div class="card-body">
            <h6 class="text-muted" *ngIf="examSchedule.status == 'InProgress' && mode=='edit'">Cannot edit InProgress
                schedule</h6>

            <form #examScheduleForm (ngSubmit)="saveSchedule()">
                <div class="floating-icon" (click)="disableAll = !disableAll"
                    *ngIf="examSchedule.status != 'InProgress' && disableAll">
                    <mat-icon class="mat-icon-button icon-lg " svgIcon="mat:edit" title="Edit"></mat-icon>
                    <!-- <b>Edit</b> -->

                </div>
                <div class="row row-cols-3">
                    <div class="col" *ngIf="isFromCandidate">
                        <label class="form-label">Examination</label>
                        <ng-select class="form-select" [(ngModel)]="examFromId" [ngModelOptions]="{ standalone: true }">
                            <ng-option selected value="0" disabled>Select Examination</ng-option>
                            <ng-option *ngFor="let exam of examList"
                                [value]="exam.id">{{exam.examinationName}}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col"  >
                        <label for="examNo" class="form-label">Candidate Number</label>
                        <input type="text" class="form-control" id="examNo" [(ngModel)]="examSchedule.examNo"  (ngModelChange)="onExamNoChange($event)"
                          (focus)="openLookup()" (keydown.escape)="closeLookup()" autocomplete="off" [disabled]="disableAll" name="examNo" #lookupContainer> 
                            <div *ngIf="showLookup && searchResults?.length" class="list-group position-absolute w-30">
                                <button class="list-group-item list-group-item-action" *ngFor="let item of searchResults"
                                    (click)="selectExamNo(item.examNo)">
                                    {{ item.examNo }}, {{ item.fullName }}
                                </button>
                            </div>
                    </div>

                    <div class="col">
                        <label for="startDateTime" class="form-label">Start Date Time</label>
                        <input type="datetime-local" class="form-control" id="startDateTime"
                            [(ngModel)]="examSchedule.startDateTime" [disabled]="disableAll" name="startDateTime">
                    </div>
                    <div class="col">
                        <label for="endDateTime" class="form-label">End Date Time</label>
                        <input type="datetime-local" class="form-control" id="endDateTime"
                            [(ngModel)]="examSchedule.endDateTime" [disabled]="disableAll" name="endDateTime">
                    </div>
                    <div class="col">
                        <label for="extraField1" class="form-label">Extra Field 1</label>
                        <input type="text" class="form-control" id="extraField1" [(ngModel)]="examSchedule.extraField1"
                            [disabled]="disableAll" name="extraField1">
                    </div>
                    <div class="col">
                        <label for="extraField2" class="form-label">Extra Field 2</label>
                        <input type="text" class="form-control" id="extraField2" [(ngModel)]="examSchedule.extraField2"
                            [disabled]="disableAll" name="extraField2">
                    </div>
                    <div class="col">
                        <label for="extraField3" class="form-label">Extra Field 3</label>
                        <input type="text" class="form-control" id="extraField3" [(ngModel)]="examSchedule.extraField3"
                            [disabled]="disableAll" name="extraField3">
                    </div>
                    <div class="col">
                        <label for="extraField4" class="form-label">Extra Field 4</label>
                        <input type="text" class="form-control" id="extraField4" [(ngModel)]="examSchedule.extraField4"
                            [disabled]="disableAll" name="extraField4">
                    </div>
                    <div class="col">
                        <label for="examinationID" class="form-label">Examination ID</label>
                        <input type="number" min="0" class="form-control" id="examinationID"
                            [(ngModel)]="examSchedule.examinationID" disabled name="examinationID">
                    </div>
                    <div class="col">
                        <label for="actualStartDateTime" class="form-label">Actual Start Date Time</label>
                        <input type="datetime-local" class="form-control" id="actualStartDateTime"
                            [(ngModel)]="examSchedule.actualStartDateTime" disabled name="actualStartDateTime">
                    </div>
                    <div class="col">
                        <label for="addedMinutes" class="form-label">Added Minutes</label>
                        <input type="number" min="0" class="form-control" id="addedMinutes"
                            [(ngModel)]="examSchedule.addedMinutes" disabled name="addedMinutes">
                    </div>
                    <div class="col">
                        <label for="totalAddedTimeInSeconds" class="form-label">Total Added Time (Seconds)</label>
                        <input type="number" min="0" class="form-control" id="totalAddedTimeInSeconds"
                            [(ngModel)]="examSchedule.totalAddedTimeInSeconds" disabled name="totalAddedTimeInSeconds">
                    </div>


                    <div class="col">
                        <label for="actualEndDateTime" class="form-label">Actual End Date Time</label>
                        <input type="datetime-local" class="form-control" id="actualEndDateTime"
                            [(ngModel)]="examSchedule.actualEndDateTime" disabled name="actualEndDateTime">
                    </div>
                    <div class="col">
                        <label for="status" class="form-label">Status</label>
                        <input type="text" class="form-control" id="status" [(ngModel)]="examSchedule.status" disabled
                            name="status">
                    </div>
                    <div class="col">
                        <label for="score" class="form-label">Score</label>
                        <input type="number" min="0" class="form-control" id="score" [(ngModel)]="examSchedule.score"
                            disabled name="score">
                    </div>
                    <div class="col">
                        <label for="percentageScore" class="form-label">Percentage Score</label>
                        <input type="number" min="0" class="form-control" id="percentageScore"
                            [(ngModel)]="examSchedule.percentageScore" disabled name="percentageScore">
                    </div>
                    <div class="col">
                        <label for="focusLossCount" class="form-label">Focus Loss Count</label>
                        <input type="number" min="0" class="form-control" id="focusLossCount"
                            [(ngModel)]="examSchedule.focusLossCount" disabled name="focusLossCount">
                    </div>
                    <div class="col">
                        <label for="examStartCount" class="form-label">Exam Start Count</label>
                        <input type="number" min="0" class="form-control" id="examStartCount"
                            [(ngModel)]="examSchedule.examStartCount" disabled name="examStartCount">
                    </div>

                    <div class="col">
                        <label for="sEBConfigKey" class="form-label">SEB Config Key</label>
                        <input type="text" class="form-control" id="sEBConfigKey"
                            [(ngModel)]="examSchedule.sEBConfigKey" disabled name="sEBConfigKey">
                    </div>
                    <div class="col">
                        <label for="sEBConfigKeyVersion" class="form-label">SEB Config Key Version</label>
                        <input type="number" min="0" class="form-control" id="sEBConfigKeyVersion"
                            [(ngModel)]="examSchedule.sEBConfigKeyVersion" disabled name="sEBConfigKeyVersion">
                    </div>
                    <div class="col">
                        <label for="interviewProctorRequestID" class="form-label">Interview Proctor Request ID</label>
                        <input type="number" min="0" class="form-control" id="interviewProctorRequestID"
                            [(ngModel)]="examSchedule.interviewProctorRequestID" disabled
                            name="interviewProctorRequestID">
                    </div>


                    <div class="col">
                        <label for="attempt" class="form-label">Attempt</label>
                        <input type="number" min="0" class="form-control" id="attempt"
                            [(ngModel)]="examSchedule.attempt" disabled name="attempt">
                    </div>
                    <div class="col">
                        <label for="timeTaken" class="form-label">Time Taken</label>
                        <input type="text" class="form-control" id="timeTaken" [(ngModel)]="examSchedule.timeTaken"
                            disabled name="timeTaken">
                    </div>
                    <div class="col">
                        <label for="lastInteraction" class="form-label">Last Interaction</label>
                        <input type="text" class="form-control" id="lastInteraction"
                            [(ngModel)]="examSchedule.lastInteraction" disabled name="lastInteraction">
                    </div>
                    <div class="col">
                        <label for="networkAvailabilityScore" class="form-label">Network Availability Score</label>
                        <input type="number" min="0" class="form-control" id="networkAvailabilityScore"
                            [(ngModel)]="examSchedule.networkAvailabilityScore" disabled
                            name="networkAvailabilityScore">
                    </div>

                    <div class="col">
                        <label for="recordingProcessStatus" class="form-label">Recording Process Status</label>
                        <input type="text" class="form-control" id="recordingProcessStatus"
                            [(ngModel)]="examSchedule.recordingProcessStatus" disabled name="recordingProcessStatus">
                    </div>

                    <div class="col">
                        <label for="randomGuid" class="form-label">Random GUID</label>
                        <input type="text" class="form-control" id="randomGuid" [(ngModel)]="examSchedule.randomGuid"
                            disabled name="randomGuid">
                    </div>
                    <div class="col">
                        <label for="restartReason" class="form-label">Restart Reason</label>
                        <input type="text" class="form-control" id="restartReason"
                            [(ngModel)]="examSchedule.restartReason" disabled name="restartReason">
                    </div>
                    <div class="col">
                        <label for="retakeCount" class="form-label">Retake Count</label>
                        <input type="number" min="0" class="form-control" id="retakeCount"
                            [(ngModel)]="examSchedule.retakeCount" disabled name="retakeCount">
                    </div>
                    <div class="col">
                        <label for="examiner" class="form-label">Examiner</label>
                        <input type="text" class="form-control" id="examiner" [(ngModel)]="examSchedule.examiner"
                            disabled name="examiner">
                    </div>
                    <div class="col">
                        <label for="lastCheckedForImport" class="form-label">Last Checked For Import</label>
                        <input type="text" class="form-control" id="lastCheckedForImport"
                            [(ngModel)]="examSchedule.lastCheckedForImport" disabled name="lastCheckedForImport">
                    </div>
                    <div class="col">
                        <label for="lastUpdateId" class="form-label">Last Update ID</label>
                        <input type="text" class="form-control" id="lastUpdateId"
                            [(ngModel)]="examSchedule.lastUpdateId" disabled name="lastUpdateId">
                    </div>



                </div>
                <div class="row row-cols-5 mt-3">
                    <div class="col">
                        <div class="form-group">

                            <input type="checkbox" class="custom-control-input mr-1" id="examPaused"
                                [(ngModel)]="examSchedule.examPaused" disabled name="examPaused">
                            <label for="examPaused" class="form-label">Exam Paused</label>

                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">

                            <input type="checkbox" class="custom-control-input mr-1" id="canTakeExam"
                                [(ngModel)]="examSchedule.canTakeExam" disabled name="canTakeExam">
                            <label for="canTakeExam" class="form-label">Can Take Exam</label>
                        </div>
                    </div>

                    <!-- <div class="col">
                        <div class="form-group">

                            <input type="checkbox" class="custom-control-input mr-1" id="viewedQuestions"
                                [(ngModel)]="examSchedule.viewedQuestions" disabled name="viewedQuestions">
                            <label for="viewedQuestions" class="form-label">Viewed Questions</label>

                        </div>
                    </div> -->
                    <div class="col">
                        <div class="form-group">

                            <input type="checkbox" class="custom-control-input mr-1" id="overrideAIPreventExamStart"
                                [(ngModel)]="examSchedule.overrideAIPreventExamStart" name="overrideAIPreventExamStart"
                                [disabled]="disableAll">
                            <label for="overrideAIPreventExamStart" class="form-label">Override AI Prevent Exam
                                Start</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">

                            <input type="checkbox" class="custom-control-input mr-1" id="allowExternalWebcam"
                                [(ngModel)]="examSchedule.allowExternalWebcam" name="allowExternalWebcam"
                                [disabled]="disableAll">
                            <label for="allowExternalWebcam" class="form-label">Allow External Webcam</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <input type="checkbox" class="custom-control-input mr-1" id="recordingDeleted"
                                [(ngModel)]="examSchedule.recordingDeleted" disabled name="recordingDeleted">
                            <label for="recordingDeleted" class="form-label">Recording Deleted</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <input type="checkbox" class="custom-control-input mr-1" id="disableSEB"
                                [(ngModel)]="examSchedule.disableSEB" [disabled]="disableAll" name="disableSEB">
                            <label for="disableSEB" class="form-label">Disable SEB</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="form-group">
                            <input type="checkbox" class="custom-control-input mr-1" id="overrideRequireSecondView"
                                [(ngModel)]="examSchedule.overrideRequireSecondView" [disabled]="disableAll"
                                name="overrideRequireSecondView">
                            <label for="overrideRequireSecondView" class="form-label">Override Require Second
                                View</label>
                        </div>
                    </div>
                </div>
                <div class="row mt-3  d-flex justify-content-center" *ngIf="examSchedule.status != 'InProgress'">
                    <div class=" d-flex justify-content-center">
                        <button type="submit" class="btn btn-primary col-md-5 mr-1"
                            [disabled]="disableAll">Save</button>
                        <button type="button" class="btn btn-secondary col-md-5" (click)="cancel()">Cancel</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>